import { type FC, useMemo, type RefObject } from 'react';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import { registerHOTModules } from '@/support/hot';
import { ScoringScaleEditor } from '@/components/UI/SpreadSheet/editors/ScoringScaleEditor';
import { buildColumns, initBulkAddObservationTypesSettings } from './BulkAddObservationTypes.utils';

import type { ValidationData } from '@/utils/observationTypeValidation';

registerHOTModules();
ScoringScaleEditor.register();

export interface BulkAddObservationTypesTableProps {
  data: Array<Array<string>>;
  innerRef: RefObject<HotTableRef>;
  validationData: ValidationData | null;
  setInvalid: (invalid: boolean) => void;
}

const BulkAddObservationTypesTable: FC<BulkAddObservationTypesTableProps> = ({
  data,
  innerRef,
  validationData,
  setInvalid,
}) => {
  const columns = useMemo(
    () =>
      buildColumns({
        validationData,
        hotTableRef: innerRef,
      }),
    [validationData, innerRef]
  );

  const settings = useMemo<SpreadsheetSettings>(() => initBulkAddObservationTypesSettings(columns), [columns]);

  return (
    <div className="mv3 w-100 overflow-auto ow-spreadsheet-styles" data-testid="observation-types-spreadsheet">
      <Spreadsheet
        data={data}
        settings={settings}
        innerRef={innerRef}
        addCol={false}
        setInvalid={setInvalid}
        autoAddRow
        enableRowHeaderControls
        modalView
        fillHandle={false}
        testPrefix="bulk-add-observation-types"
      />
    </div>
  );
};

export default BulkAddObservationTypesTable;
